import { createI18n } from "vue-i18n"
import GlobalConfig, { chinaAppName } from "@/config/config.js"
import { getCurrentInstance } from "vue"

import commonEn from "./en/common.json"
import commonCn from "./cn/common.json"
import commonJa from "./ja/common.json"
import commonKo from "./ko/common.json"
import commonSp from "./sp/common.json"
import commonPo from "./po/common.json"
import commonZHCN from "./zh-CN/common.json"
import commonZHTW from "./zh-TW/common.json"
import commonDE from "./de/common.json"
import commonFR from "./fr/common.json"
import commonIT from "./it/common.json"
import commonRU from "./ru/common.json"

import storeEn from "./en/store.json"
import storeCn from "./cn/store.json"
import storeJa from "./ja/store.json"
import storeKo from "./ko/store.json"
import storeSp from "./sp/store.json"
import storePo from "./po/store.json"
import storeZHCN from "./zh-CN/store.json"
import storeZHTW from "./zh-TW/store.json"
import storeDE from "./de/store.json"
import storeFR from "./fr/store.json"
import storeIT from "./it/store.json"
import storeRU from "./ru/store.json"

import createEn from "./en/create.json"
import createCn from "./cn/create.json"
import createJa from "./ja/create.json"
import createKo from "./ko/create.json"
import createSp from "./sp/create.json"
import createPo from "./po/create.json"
import createZHCN from "./zh-CN/create.json"
import createZHTW from "./zh-TW/create.json"
import createDE from "./de/create.json"
import createFR from "./fr/create.json"
import createIT from "./it/create.json"
import createRU from "./ru/create.json"

import creditEn from "./en/credit.json"
import creditCn from "./cn/credit.json"
import creditJa from "./ja/credit.json"
import creditKo from "./ko/credit.json"
import creditSp from "./sp/credit.json"
import creditPo from "./po/credit.json"
import creditZHCN from "./zh-CN/credit.json"
import creditZHTW from "./zh-TW/credit.json"
import creditDE from "./de/credit.json"
import creditFR from "./fr/credit.json"
import creditIT from "./it/credit.json"
import creditRU from "./ru/credit.json"

import libraryCn from "./cn/library.json"
import libraryEn from "./en/library.json"
import libraryJa from "./ja/library.json"
import libraryKo from "./ko/library.json"
import librarySp from "./sp/library.json"
import libraryPo from "./po/library.json"
import libraryZHCN from "./zh-CN/library.json"
import libraryZHTW from "./zh-TW/library.json"
import libraryDE from "./de/library.json"
import libraryFR from "./fr/library.json"
import libraryIT from "./it/library.json"
import libraryRU from "./ru/library.json"

import mineCn from "./cn/mine.json"
import mineEn from "./en/mine.json"
import mineJa from "./ja/mine.json"
import mineKo from "./ko/mine.json"
import mineSp from "./sp/mine.json"
import minePo from "./po/mine.json"
import mineZHCN from "./zh-CN/mine.json"
import mineZHTW from "./zh-TW/mine.json"
import mineDE from "./de/mine.json"
import mineFR from "./fr/mine.json"
import mineIT from "./it/mine.json"
import mineRU from "./ru/mine.json"

import landCn from "./cn/land.json"
import landEn from "./en/land.json"
import landJa from "./ja/land.json"
import landKo from "./ko/land.json"
import landSp from "./sp/land.json"
import landPo from "./po/land.json"
import landZHCN from "./zh-CN/land.json"
import landZHTW from "./zh-TW/land.json"
import landDE from "./de/land.json"
import landFR from "./fr/land.json"
import landIT from "./it/land.json"
import landRU from "./ru/land.json"

import loginCn from "./cn/login.json"
import loginEn from "./en/login.json"
import loginJa from "./ja/login.json"
import loginKo from "./ko/login.json"
import loginSp from "./sp/login.json"
import loginPo from "./po/login.json"
import loginZHCN from "./zh-CN/login.json"
import loginDE from "./de/login.json"
import loginFR from "./fr/login.json"
import loginIT from "./it/login.json"
import loginRU from "./ru/login.json"

import paymentCn from "./cn/payment.json"
import paymentEn from "./en/payment.json"
import paymentJa from "./ja/payment.json"
import paymentKo from "./ko/payment.json"
import paymentSp from "./sp/payment.json"
import paymentPo from "./po/payment.json"
import paymentZHCN from "./zh-CN/payment.json"
import paymentZHTW from "./zh-TW/payment.json"
import paymentDE from "./de/payment.json"
import paymentFR from "./fr/payment.json"
import paymentIT from "./it/payment.json"
import paymentRU from "./ru/payment.json"

import editorCn from "./cn/editor.json"
import editorEn from "./en/editor.json"
import editorJa from "./ja/editor.json"
import editorKo from "./ko/editor.json"
import editorSp from "./sp/editor.json"
import editorPo from "./po/editor.json"
import editorZHCN from "./zh-CN/editor.json"
import editorZHTW from "./zh-TW/editor.json"
import editorDE from "./de/editor.json"
import editorFR from "./fr/editor.json"
import editorIT from "./it/editor.json"
import editorRU from "./ru/editor.json"

import ttsCn from "./cn/tts.json"
import ttsEn from "./en/tts.json"
import ttsJa from "./ja/tts.json"
import ttsKo from "./ko/tts.json"
import ttsSp from "./sp/tts.json"
import ttsPo from "./po/tts.json"
import ttsZHCN from "./zh-CN/tts.json"
import ttsZHTW from "./zh-TW/tts.json"
import ttsDE from "./de/tts.json"
import ttsFR from "./fr/tts.json"
import ttsIT from "./it/tts.json"
import ttsRU from "./ru/tts.json"


import { getCookie } from "@/utils/cookieUtils"

const cn = {
  common: commonCn,
  store: storeCn,
  create: createCn,
  credit: creditCn,
  mine: mineCn,
  library: libraryCn,
  land: landCn,
  login: loginCn,
  payment: paymentCn,
  editor: editorCn,
  tts: ttsCn,
}

export const messages = {
  en: {
    common: commonEn,
    store: storeEn,
    create: createEn,
    credit: creditEn,
    mine: mineEn,
    library: libraryEn,
    land: landEn,
    login: loginEn,
    payment: paymentEn,
    editor: editorEn,
    tts: ttsEn,
  },
  ja: {
    common: commonJa,
    store: storeJa,
    create: createJa,
    credit: creditJa,
    mine: mineJa,
    library: libraryJa,
    land: landJa,
    login: loginJa,
    payment: paymentJa,
    editor: editorJa,
    tts: ttsJa,
  },
  ko: {
    // 韩语
    common: commonKo,
    store: storeKo,
    create: createKo,
    credit: creditKo,
    mine: mineKo,
    library: libraryKo,
    land: landKo,
    login: loginKo,
    payment: paymentKo,
    editor: editorKo,
    tts: ttsKo,
  },
  es: {
    // 西班牙语
    common: commonSp,
    store: storeSp,
    create: createSp,
    credit: creditSp,
    mine: mineSp,
    library: librarySp,
    land: landSp,
    login: loginSp,
    payment: paymentSp,
    editor: editorSp,
    tts: ttsSp,
  },
  pt: {
    // 葡萄牙语
    common: commonPo,
    store: storePo,
    create: createPo,
    credit: creditPo,
    mine: minePo,
    library: libraryPo,
    land: landPo,
    login: loginPo,
    payment: paymentPo,
    editor: editorPo,
    tts: ttsPo,
  },
  "zh-Hans":
    GlobalConfig.appname == chinaAppName
      ? cn
      : {
          common: commonZHCN,
          store: storeZHCN,
          create: createZHCN,
          credit: creditZHCN,
          mine: mineZHCN,
          library: libraryZHCN,
          land: landZHCN,
          login: loginZHCN,
          payment: paymentZHCN,
          editor: editorZHCN,
          tts: ttsZHCN,
        },
  "zh-Hant": {
    common: commonZHTW,
    store: storeZHTW,
    create: createZHTW,
    credit: creditZHTW,
    mine: mineZHTW,
    library: libraryZHTW,
    land: landZHTW,
    login: loginZHCN,
    payment: paymentZHTW,
    editor: editorZHTW,
    tts: ttsZHTW,
  },
  de: {
    common: commonDE,
    store: storeDE,
    create: createDE,
    credit: creditDE,
    mine: mineDE,
    library: libraryDE,
    land: landDE,
    login: loginDE,
    payment: paymentDE,
    editor: editorDE,
    tts: ttsDE,
  },
  fr: {
    common: commonFR,
    store: storeFR,
    create: createFR,
    credit: creditFR,
    mine: mineFR,
    library: libraryFR,
    land: landFR,
    login: loginFR,
    payment: paymentFR,
    editor: editorFR,
    tts: ttsFR,
  },
  it: {
    common: commonIT,
    store: storeIT,
    create: createIT,
    credit: creditIT,
    mine: mineIT,
    library: libraryIT,
    land: landIT,
    login: loginIT,
    payment: paymentIT,
    editor: editorIT,
    tts: ttsIT,
  },
  ru: {
    common: commonRU,
    store: storeRU,
    create: createRU,
    credit: creditRU,
    mine: mineRU,
    library: libraryRU,
    land: landRU,
    login: loginRU,
    payment: paymentRU,
    editor: editorRU,
    tts: ttsRU,
  },
}

export const mapBrowserLanguage = (appLanguage) => {
  // 获取浏览器的首选语言
  // const browserLanguage = appLanguage ?? (!import.meta.env.SSR ? navigator.language || navigator.userLanguage : "")
  // if (!GlobalConfig.switchLanguage) return GlobalConfig.appname == chinaAppName ? "zh-Hans" : "en"

  // 定义语言映射规则
  // const languageMap = {
  //   en: ["en", "en-US", "en-GB", "en-AU", "en-CA"], // 英语
  //   "zh-Hans": ["zh", "zh-CN", "zh-Hans"], // 中文简体
  //   "zh-Hant": [, "zh-HK", "zh-MO", "zh-SG", "zh-TW", "zh-Hant"], // 中文繁体
  //   ja: ["ja", "ja-JP"], // 日语
  //   ko: ["ko", "ko-KR"], // 韩语
  //   es: ["es", "es-ES", "es-MX", "es-419"], // 西班牙语
  //   pt: ["pt", "pt-BR", "pt-PT"], // 葡萄牙语
  //   de: ["de", "de-DE"], // 德语
  //   fr: ["fr", "fr-FR"], // 法语
  //   it: ["it", "it-IT"], // 意大利语
  //   ru: ["ru", "ru-RU"], // 俄语
  // }

  // // 遍历映射规则，找到最靠近的语言
  // for (const [key, values] of Object.entries(languageMap)) {
  //   if (values.includes(browserLanguage)) {
  //     return key // 返回映射的语言代码
  //   }
  // }
  // // 如果没有匹配到，返回默认值 (如 "en")
  // return GlobalConfig.appname == chinaAppName ? "zh-Hans" : "en"
}

// const localData =
//   localStorage.getItem(GlobalConfig.localStorageGlobalKey) || "{}";
export const createI18nInstance = (lang) => {
  // const cookieData = getCookie(GlobalConfig.localStorageGlobalKey, cookie) || "{}"
  // const userInfo = JSON.parse(decodeURIComponent(cookieData))
  return createI18n({
    locale: lang,
    fallbackLocale: GlobalConfig.appname == chinaAppName ? "zh-Hans" : "en",
    messages,
    globalInjection: false, // 全局注入
  })
}

export function registerI18n(i18n) {
  return {
    $$t: (key, language, params) => {
      if (typeof language == "object") {
        return i18n.global.t(key, language)
      }
      if (typeof language == "string" && Object.keys(messages).includes(language)) {
        return getDataByFields(messages[language], key, params)
      }
      return i18n.global.t(key, params)
    },
    $$tValue: (key, params) => {
      return i18n.global.t(key, params)
    },
    $$tm: (key) => {
      return i18n.global.tm(key)
    },
    $$language: (language) => {
      if (language && Object.keys(messages).includes(language)) {
        if (i18n.global.locale != language) {
          i18n.global.locale = language
        }
      }
      return i18n.global.locale
    },
  }
}

export const $$tValue = (key, params) => {
  if (!import.meta.env.SSR) {
    const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.())?.appContext?.config?.globalProperties
    return globalProperties?.$i18n?.$$tValue(key, params) ?? ""
  }
  return ""
}

export const $$t = (key, language, params) => {
  if (!import.meta.env.SSR) {
    const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.())?.appContext?.config?.globalProperties
    return globalProperties?.$i18n?.$$t(key, language, params) ?? ""
  }
  return ""
}

export const $$tm = (key) => {
  if (!import.meta.env.SSR) {
    const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.())?.appContext?.config?.globalProperties
    return globalProperties?.$i18n?.$$tm(key) ?? ""
  }
  return ""
}

export const $$language = (language) => {
  if (!import.meta.env.SSR) {
    const globalProperties = (getCurrentInstance() || window?.$getVueCurrentInstance?.())?.appContext?.config?.globalProperties
    return globalProperties?.$i18n?.$$language(language)
  }
  return "en"
}

export const LanguageList = [
  {
    key: "en",
    label: "English",
  },
  {
    key: "zh-Hans",
    label: "中文（简体）",
  },
  {
    key: "zh-Hant",
    label: "中文（繁體）", // 或 "繁體中文"
  },
  {
    key: "ja",
    label: "日本語",
  },
  {
    key: "ko",
    label: "한국어", // 或 "한국어 (Korean)"
  },
  {
    key: "es",
    label: "Español", // 或保持 "Español"
  },
  {
    key: "pt",
    label: "Português",
  },
  {
    key: "de",
    label: "Deutsch",
  },
  {
    key: "fr",
    label: "Français", // 首字母大写
  },
  {
    key: "it",
    label: "Italiano",
  },
  {
    key: "ru",
    label: "Русский язык", // 或保持 "Русский язык"
  },
]

export const setLangetoServer = (lang)=> {
  if (lang === "zh-Hans") {
    return "zh-CN"
  } else if (lang === "zh-Hant") {
    return "zh-TW"
  } else {
    return lang
  }
}